import {useTranslation} from "react-i18next";

import DurationDisplay from "components/datestimes/DurationDisplay";
import ConditionalRender from "components/ConditionalRender";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableRouteStatic = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Tt} = useTranslation("tags");

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.duplicate.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th key="-1" style={{...stickyHeaderStyle}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onClick={onClick}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.description}</td>
                        <td>{_Tc("downloads." + item.download_type)}</td>
                        <td>{_Tc("wastes." + item.waste_type)}</td>
                        <td>{item.checkpoints.length}</td>
                        <td>
                            <ConditionalRender
                                condition={item.duration !== "0.0"}
                                fallback={
                                    <FontAwesomeIcon
                                        icon="circle-xmark"
                                        className="text-warning"
                                        title={_Tt("route.incomplete")}
                                    />
                                }>
                                {DurationDisplay({
                                    seconds: item.duration,
                                    format: "HH:mm",
                                })}
                            </ConditionalRender>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableRouteStatic;
